const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const MONTH = 30 * DAY;
const YEAR = 365 * DAY;

const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

/**
 * Format a timestamp as a relative time string (e.g. "2 hours ago", "3 days ago").
 * Falls back to an absolute date for very old timestamps (>1 year).
 */
export function formatRelativeTime(timestamp: number): string {
	const now = Date.now();
	const diffSeconds = Math.round((timestamp - now) / 1000);
	const absDiff = Math.abs(diffSeconds);

	if (absDiff < MINUTE) return rtf.format(diffSeconds, "second");
	if (absDiff < HOUR) return rtf.format(Math.round(diffSeconds / MINUTE), "minute");
	if (absDiff < DAY) return rtf.format(Math.round(diffSeconds / HOUR), "hour");
	if (absDiff < WEEK) return rtf.format(Math.round(diffSeconds / DAY), "day");
	if (absDiff < MONTH) return rtf.format(Math.round(diffSeconds / WEEK), "week");
	if (absDiff < YEAR) return rtf.format(Math.round(diffSeconds / MONTH), "month");

	return new Date(timestamp).toLocaleDateString("en", {
		year: "numeric",
		month: "short",
		day: "numeric",
	});
}
